type StorageType = 'local' | 'session';

const getStorage = (type: StorageType = 'local'): Storage => {
  return type === 'local' ? localStorage : sessionStorage
}


/**
 * Sets JSON data to storage
 */
export const setStorageItem = <T>(
  key: string,
  value: T,
  type: StorageType = 'local',
): void => {
  try {
    const storage = getStorage(type)
    const serializedValue = JSON.stringify(value)
    storage.setItem(key, serializedValue)
  } catch (error) {
    console.error('Error saving to storage:', error)
    throw new Error('Failed to save data to storage')
  }
}

/**
 * Gets JSON data from storage
 */
export const getStorageItem = <T>(
  key: string,
  type: StorageType = 'local',
): T | null => {
  try {
    const storage = getStorage(type)
    const item = storage.getItem(key)
    if (item === null) {
      return null
    }
    return JSON.parse(item) as T
  } catch (error) {
    console.error('Error reading from storage:', error)
    return null
  }
}
